<app-user-message *ngIf="showForm" [type]="color" [title]="title" [actionLabel]="actionLabel" (action)="onAction.emit()" (close)="Close()"><span [innerHTML]="formattedMessage"></span></app-user-message>
